// api
import { fetchUniversityDetails } from "@/api/university";

// actions
import {
	showToasterMessage,
	setIsLoading,
} from "@/store/actions/commonActions";
import { initializeUniversityDetails } from "@/store/actions/universityDetailsActions";
import { goToRoute } from "@/store/actions/navigationActions";
import { deserializeUniversityDetails } from "@/utils/deserializers/universityDetailsDeserializer";

// utils
import routePaths from "@/utils/route-paths";
import { toasterMessage as TM } from "@/utils/toaster-msg";
import { storeCredentialsInSession } from "@/utils/session";

const getLoginPageProps = (dispatch) => {
	const loginWithURL = (payload) => {
		dispatch(goToRoute(routePaths.REDIRECTION));
		if (payload.university_code && payload.fair_id) {
			fetchUniversityDetails(payload)
				.then((res) => {
					dispatch(
						initializeUniversityDetails(deserializeUniversityDetails(res.data))
					);
					storeCredentialsInSession(
						res.data.university_code || payload.university_code,
						payload.fair_id,
						res.data.access_token
					);
					dispatch(goToRoute(routePaths.DASHBOARD));
				})

				.catch((err) => {
					dispatch(goToRoute(routePaths.UNIVERSITY_LOGIN));
					console.log(err);
				});
			}
	};

	const LoginButtonOnClick = (payload) => {
		if (payload.university_code && payload.fair_id) {
			dispatch(setIsLoading(true));
			fetchUniversityDetails(payload)
				.then((res) => {
					dispatch(
						initializeUniversityDetails(deserializeUniversityDetails(res.data))
					);
					storeCredentialsInSession(
						res.data.university_code || payload.university_code,
						payload.fair_id,
						res.data.access_token
					);
					dispatch(goToRoute(routePaths.DASHBOARD));
				})
				.catch((err) => {
					dispatch(
						showToasterMessage(TM.loginFailed.msg, TM.loginFailed.color)
					);
					dispatch(setIsLoading(false));
					console.log(err);
				});
		} else if (!payload.university_code) {
			dispatch(
				showToasterMessage(
					TM.incorrectUniversityId.msg,
					TM.incorrectUniversityId.color
				)
			);
		} else if (!payload.fair_id) {
			dispatch(
				showToasterMessage(TM.incorrectFairId.msg, TM.incorrectFairId.color)
			);
		}
	};

	return {
		loginWithURL,
		heading: {
			title: "Hello there! Welcome to Azent Overseas Education",
			subTitle: "Please fill in the details to proceed further",
		},
		inputFields: {
			inputBox: {
				label: "University Id",
				helpText: "Enter University ID ,mentioned in your Email",
			},
			selectBox: {
				label: "Event",
				values: [
					{
						value: "3242457000443837003",
						name: "Azent Overseas Education Fair - Bangalore - 30 July 2022",
					},
					{
						value: "3242457000443837015",
						name: "Azent Overseas Education Fair - Surat - 05 August 2022",
					},
					{
						value: "3242457000443837027",
						name: "Azent Overseas Education Fair - Vadodara - 06 August 2022",
					},
					{
						value: "3242457000443837039",
						name: "Azent Overseas Education Fair - Ahmedabad - 07 August 2022",
					},
					{
						value: "3242457000443837051",
						name: "Azent Overseas Education Fair - Vijayawada - 19 August 2022",
					},
					{
						value: "3242457000443837063",
						name: "Azent Overseas Education Fair - Hyderabad - 20 August 2022",
					},
					{
						value: "3242457000443837075",
						name: "Azent Overseas Education Fair - Chennai - 21 August 2022",
					},
					{
						value: "3242457000443837087",
						name: "Azent Overseas Education Fair - Jaipur - 27 August 2022",
					},
					{
						value: "3242457000443837099",
						name: "Azent Overseas Education Fair - Mumbai & Thane - 28 August 2022",
					},
					{
						value: "3242457000463707005",
						name: "Azent Overseas Education Online Fair - 09th August 2022",
					},
				],
			},
		},
		loginButton: {
			fullWidth: true,
			variant: "contained",
			color: "success",
			label: "Get Started",
			onClick: LoginButtonOnClick,
		},
	};
};

export default getLoginPageProps;
